module.exports = __webpack_public_path__ + "img/crystal-palace.3aac277b.png";